// @flow

import _ from 'lodash';

export const partnerTiers = {
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM',
};

export type PartnerTier = $Keys<typeof partnerTiers>;

export function isPartnerSilverOrMore(partnerStatus: PartnerTier) {
  return _.omit(partnerTiers, ['partnerTiers', 'BRONZE']).hasOwnProperty(
    partnerStatus
  );
}
